<template>
  <el-form-item @mouseenter.stop.native="controlMouseOver(component, index)" @click.native="controlClick(component, index)" class="rc-input-run" :prop="getProp" :rules="rules" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName"
                :title="component.name" :label-width="labelParameter.width" :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}" ref="elFormItem">
    <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
    <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
    </el-tooltip>
    <el-input :class="[inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
              :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
              @input="setValue"
              @change="customChangeEvent"
              :value="getComponentValue"
              :disabled="disabled || component.properties.readonly"
              :placeholder="component.properties.placeholder"
              :title="getComponentValue||component.properties.placeholder"
              maxlength="300"
              @focus="inputFocus(component, index)"
              @blur="validateFormItem"></el-input>
  </el-form-item>
</template>

<script>
import {componentMixin, inputMixin, calculationMixin, defaultValueMixin} from './mixins'

export default {
  name: 'rc-input',
  mixins: [componentMixin, inputMixin, calculationMixin, defaultValueMixin],
  props: {
    component: Object,
    value: {
      default: ''
    },
    disabled: Boolean,
    labelParameter: Object,
    index: [Number, String],
    tableCtrlKey: Boolean
  },
  data () {
    return {
      tempValue: '',
      state: false,
      hasSpaceValue: ''
    }
  },
  methods: {
    setValue (val) {
      this.tempValue = val
      this.state = true
      this.updateValue(val)
    },
    updateValue (val) {
      // 如果有空格,hasSpaceValue 先暂存空格
      val.match(/^\s+\s+$/) ? this.hasSpaceValue = val : this.hasSpaceValue = ''
      val = val === ' ' ? ' ' : val.trim()
      // 归档控件才需要传值
      if (this.component.archive.enable) {
        this.update(val)
      }
      this.$nextTick(() => {
        this.executeFunctions('change')
        // 实时校验
        if (!this.component.properties.limit.triggerBlur) {
          this.$refs.elFormItem.validate('change')
        }
      })
    }
  },
  computed: {
    getComponentValue () {
      // state是为了编辑的时候,如果本来有值,而值清空了应该是新的值
      if (this.component.archive.enable) {
        if (this.tempValue || (this.tempValue === '' && this.state)) {
          return this.tempValue
        } else {
          return this.value
        }
      } else {
        return this.tempValue
      }
    }
  },
  watch: {
    value (val) {
      // 定制需要直接改dataService的值,在归档情况下才行
      if (this.component.archive.enable) {
        this.hasSpaceValue ? this.tempValue = this.hasSpaceValue : this.tempValue = val
        this.hasSpaceValue = ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-input.vue